<template>
  <!-- <div class="navigation-meta">
    <kf-search-bar
      v-if="searchAction"
      class="hidden md:flex"
      :search-action="searchAction"
      :search-placeholder="searchPlaceholder"
    />
  </div> -->

  <div class="navigation-meta">
    <ul class="navigation-meta-list">
      <li class="navigation-meta-list-item">
        <kf-language-selector
          v-if="languages && currentLocale"
          :languages="languages"
          :current-locale="currentLocale"
        />
      </li>
    </ul>
    <kf-search-bar
      v-if="searchAction"
      :search-action="searchAction"
      :search-placeholder="searchPlaceholder"
    />
  </div>
</template>

<script>
import KfLanguageSelector from '@/components/language-selector/LanguageSelector.vue';
import KfSearchBar from '@/components/search/SearchBar.vue';

export default {
  name: 'NavigationMeta',
  components: {
    KfLanguageSelector,
    KfSearchBar,
  },
  props: {
    navItems: {
      type: Array,
      default: null,
    },
    languages: {
      type: Array,
      default: null,
    },
    currentLocale: {
      type: String,
      default: null,
    },
    searchAction: {
      type: String,
      default: null,
    },
    searchPlaceholder: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="postcss">
.navigation-meta {
  @apply flex items-start relative z-20 flex-col;

  &-list {
    @apply flex items-baseline pt-3 pb-0;

    &-item {
      @apply ml-8;
    }

    &-link {
      @apply no-underline text-sm text-black;
    }

    @screen lg {
      @apply pb-6;
      padding-top: 11px;
    }
  }

  .search-bar-wrapper {
    @apply mt-1;
  }
}
</style>
